export interface GtagEventParams {
  event_category: string;
  event_label: string;
  event_value?: number | string | object;
  item_name?: string;
  creative_name?: string;
  user_id?: number;
}
declare global {
  interface Window {
    gtag?: (event: string, action: string, params: GtagEventParams) => void;
  }
}

export enum AnalyticsCategory {
  FUSEBASE = 'fusebase_new',
  FUSEBASE_08_24 = 'fusebase_08_24',
  FUSEBASE_10_16 = 'fusebase_10_16',
  LIMIT = 'Limit',
  AI_ASSISTANT = 'ai_assistant',
  TRIAL_START_POPUP = 'trial_start_popup',
  TRIAL_END_POPUP = 'trial_end_popup',
  UPGRADE_POPUP = 'upgrade_popup',
  ESIGN = 'e-sign',
  DASHBOARD = 'dashboard_012025',
}

let analyticsUserId: number;
/**
 * Sets userId to be sent for all the events when using trackEvent
 * @param userId
 */
export function setAnalyticsUser(userId: number) {
  analyticsUserId = userId;
}

export function trackEvent<Value extends string | number | object = number>(
  action: string,
  category: AnalyticsCategory,
  label: string,
  value?: Value
) {
  const gtag = window.gtag;
  console.log('event', action, {
    event_category: category,
    event_label: label,
    event_value: value,
    user_id: analyticsUserId,
  });
  if (gtag) {
    const params: GtagEventParams = {
      event_category: category,
      event_label: label,
      event_value: value,
      user_id: analyticsUserId,
    };
    gtag('event', action, params);
  }
}
